const map = {
	"./activity.js": 4745,
	"./balance.js": 374,
	"./bank.js": 9486,
	"./boats.js": 125,
	"./booking.js": 6689,
	"./broadcast.js": 6833,
	"./calccat.js": 197,
	"./calculator.js": 5692,
	"./cardetails.js": 7844,
	"./changepassword.js": 6725,
	"./chat.js": 1066,
	"./common.js": 4001,
	"./containers.js": 5856,
	"./customs.js": 8382,
	"./dashboard.js": 762,
	"./earnings.js": 1339,
	"./financing.js": 4627,
	"./integrations.js": 1083,
	"./login.js": 9403,
	"./messaging.js": 8010,
	"./news.js": 6411,
	"./notifications.js": 8970,
	"./permissions.js": 4114,
	"./reports.js": 6233,
	"./settings.js": 2085,
	"./survey.js": 6438,
	"./tickets.js": 8227,
	"./transactions.js": 7009,
	"./users.js": 8734,
	"./vehicles.js": 3309
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2833;